var map = {
	"./animal-crossing.png": "4d26",
	"./arms.png": "14b3",
	"./banjo-kazooie.png": "01af",
	"./bayonetta.png": "486e",
	"./castlevania.png": "3c4a",
	"./donkey-kong.png": "c901",
	"./dragon-quest-xi.png": "8f74",
	"./duck-hunt.png": "d937",
	"./earthbound.png": "47b3",
	"./f-zero.png": "210c",
	"./fatal-fury.png": "ff6f",
	"./final-fantasy.png": "6453",
	"./fire-emblem.png": "3301",
	"./game-and-watch.png": "f1de",
	"./ice-climber.png": "3df6",
	"./kid-icarus.png": "8d65",
	"./kingdom-hearts.png": "be1c",
	"./kirby.png": "0d70",
	"./mega-man.png": "a6f3",
	"./metal-gear-solid.png": "0668",
	"./metroid.png": "a6b4",
	"./mii.png": "2fcc",
	"./minecraft.png": "2fcc5",
	"./pac-man.png": "b2d4",
	"./persona-5.png": "6c52",
	"./pikmin.png": "d959",
	"./pokemon.png": "fcb4",
	"./punch-out.png": "f924",
	"./rob.png": "1ff7",
	"./sonic.png": "4a53",
	"./splatoon.png": "f637",
	"./star-fox.png": "1bf1",
	"./street-fighter.png": "ab62",
	"./super-mario-bros.png": "1a20",
	"./tekken.png": "94c1",
	"./the-legend-of-zelda.png": "27c3",
	"./warioware.png": "3539",
	"./wii-fit.png": "382f",
	"./xenoblade-chronicles.png": "e087",
	"./yoshi.png": "ce2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ae";